const TELEGRAM_METHOD_EVENTS = {
    ready: "web_app_ready",
    expand: "web_app_expand",
    requestFullscreen: "web_app_request_fullscreen",
};

export function getTelegramWebApp() {
    return window.Telegram?.WebApp || null;
}

function postTelegramWebAppEvent(eventType, eventData = {}) {
    const eventPayload = JSON.stringify(eventData);

    if (window.TelegramWebviewProxy?.postEvent) {
        window.TelegramWebviewProxy.postEvent(eventType, eventPayload);
        return true;
    }

    if (window.external?.notify) {
        window.external.notify(JSON.stringify({ eventType, eventData }));
        return true;
    }

    if (window.parent && window.parent !== window) {
        window.parent.postMessage(JSON.stringify({ eventType, eventData }), "https://web.telegram.org");
        return true;
    }

    return false;
}

export function callTelegramWebAppMethod(methodName) {
    const webApp = getTelegramWebApp();

    try {
        if (typeof webApp?.[methodName] === "function") {
            webApp[methodName]();
            return true;
        }
    } catch {
        return false;
    }

    const eventType = TELEGRAM_METHOD_EVENTS[methodName];

    if (!eventType) {
        return false;
    }

    try {
        return postTelegramWebAppEvent(eventType);
    } catch {
        return false;
    }
}
